import { createContext } from 'preact';

export type LayerContextProps = {
  getHost?: () => Element;
};

export const LayerContext = createContext<LayerContextProps>({});
